import React, { useState,useEffect } from "react";
import { Box, Typography } from "@mui/material";
import ReusableForm from "../../components/ReusableForm/ReusableForm";
import logo from "./../../assets/images/logo/light-logo.png";
import wrenchIcon from "./../../assets/images/signin/wrenchIcon.png";
import './SignIn.scss'
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { restoreLoginState } from "../../redux/slices/loginSlice";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isLoggedIn } = useSelector((state) => state.login); 
  
   // Dynamically determine formType based on URL
  const formType = location.pathname === "/signup"
    ? "signup"
    : location.pathname === "/forget-password"
    ? "forget-password"
    : "signin";
  const handleLogoClick = () => {
    navigate('/');
  };
  // Check if user is logged in on component mount
  useEffect(() => {
    dispatch(restoreLoginState()); // Restore login state from cookies
  }, [dispatch]);

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate('/'); // Redirect to home if logged in
  //   }
  // }, [isLoggedIn, navigate]);
  return (
    <Box
      sx={{
        // position: "absolute",
        top: 0,
        left: 0,
        zIndex: 2000,
        background: "linear-gradient(180deg, #0E518A 0%, #041524 100%)",
        display: "flex",
        width: "100%",
        flexDirection: { xs: "column", md: "row" },
        direction: "ltr",
        minHeight: "100vh",

      }}
    >
      {/* Left Side - Logo and Wrench Icon */}
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          color: "#fff",
          padding: "20px",
          position: "relative",


        }}
      >
        <img src={logo} alt="Logo" className="logo" onClick={handleLogoClick} style={{
          cursor: "pointer"
        }} />
        <img src={wrenchIcon} alt="Wrench Icon" className="wrench-icon" />
      </Box>

      {/* Right Side - Reusable Form */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "600px",
          padding: { xs: "20px", md: "0 120px", lg: "0 180px" },
          backgroundColor: "#fff",
          borderRadius: { xs: "20px 20px 0 0", md: "20px 0 0 20px" },
          boxShadow: "4px 4px 20px rgba(0, 0, 0, 0.1)",
          width: "100%",

        }}
      >
        <ReusableForm formType={formType} />
        {/* Footer Content */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: '9px',
              fontWeight: 400,
              lineHeight: '11.03px',
              color: '#B2B2B2',
              textDecoration: 'none',
              mb: 2
            }}
          >
            Copyright © 2024 | All Rights Reserved | Awen Powered by <a href="#" style={{ color: "#0E518A" }}>Ekad Soft</a> |{' '}
            <a href="#" style={{ textDecoration: 'none', color: '#B2B2B2', }}>Terms and Conditions</a> |{' '}
            <a href="#" style={{ textDecoration: 'none', color: '#B2B2B2', }}>Privacy Policy</a>
          </Typography>
        </Box>
      </Box>

    </Box>
  );
};

export default SignIn;
